var PRICEBREAKDOWN_ITEM_ATTRIBUTE = {
    CONCEPT_KEY: 'conceptKey',
    CONCEPT_LABEL: 'conceptLabel',
    ONE_PRICE: 'onePrice',
    ONE_PRICE_PROVIDER: 'onePriceProvider',
    ALL_PRICE: 'allPrice',
    QUANTITY: 'quantity',
    TYPE: 'type',
    FARE: 'fare',
    PROVIDER_FARE: 'providerFare',
    ALL_PRICE_PROVIDER: 'allPriceProvider',
    MARKUP: 'markup',
    TAX: 'tax',
};

module.exports = PRICEBREAKDOWN_ITEM_ATTRIBUTE;
